(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video"]) return;
  try {
    
  if (!customElements.get('shoppable-video-stories')) {
    class ShoppableVideoStories extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (this.abort || !this.isConnected) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('[data-track]');
        this.dialog = this.querySelector('[data-dialog]');
        this.player = this.querySelector('[data-player]');
        this.productList = this.querySelector('[data-product-list]');
        this.productPanel = this.querySelector('[data-product-panel]');
        this.unmute = this.querySelector('[data-unmute]');
        this.error = this.querySelector('[data-error]');
        this.motion = this.querySelector('[data-motion]');
        this.mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.previewsPaused = this.dataset.autoplay !== 'true' || this.mediaQuery.matches;
        this.visible = new Set();
        this.entries = [];
        this.querySelectorAll('[data-generated]').forEach(card => card.remove());

        this.querySelectorAll('[data-group]').forEach(group => {
          const original = group.querySelector('[data-story]');
          const primary = this.mp4(original.dataset.src);
          const extra = group.querySelector('[data-extra]').value.split(/\r?\n/).map(url => this.mp4(url)).filter(Boolean);
          original.hidden = !primary;
          if (primary) this.addEntry(original, group, primary);
          extra.forEach(url => {
            const card = original.cloneNode(true);
            card.hidden = false;
            card.dataset.generated = '';
            card.removeAttribute('data-ready');
            card.dataset.src = url;
            card.dataset.preview = url;
            card.querySelector('video').removeAttribute('src');
            group.append(card);
            this.addEntry(card, group, url);
          });
          group.hidden = !primary && !extra.length;
        });

        this.hidden = !this.entries.length && this.dataset.designMode !== 'true';
        const empty = this.querySelector('[data-empty]');
        if (empty) empty.hidden = this.entries.length > 0;
        this.motion.hidden = !this.entries.length;
        this.updateMotion();
        this.observer = new IntersectionObserver(changes => {
          changes.forEach(change => {
            const video = change.target.querySelector('video');
            if (change.isIntersecting && change.intersectionRatio >= 0.15) {
              this.visible.add(video);
              if (!video.hasAttribute('src')) {
                video.preload = 'metadata';
                video.src = change.target.dataset.preview;
              }
            } else {
              this.visible.delete(video);
            }
          });
          this.syncPreviews();
        }, { threshold: [0, 0.15] });
        this.entries.forEach(entry => this.observer.observe(entry.card));
        this.resize = new ResizeObserver(() => this.updateArrows());
        this.resize.observe(this.track);
        this.track.addEventListener('scroll', () => this.updateArrows(), { signal, passive: true });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-story')) this.open(Number(button.dataset.index), button);
          if (button.hasAttribute('data-scroll')) this.scrollCards(Number(button.dataset.scroll));
          if (button.hasAttribute('data-step')) this.show(this.index + Number(button.dataset.step));
          if (button.hasAttribute('data-close')) this.dialog.close();
          if (button.hasAttribute('data-unmute')) {
            this.player.muted = false;
            this.player.volume = 1;
            this.unmute.hidden = true;
            this.player.focus();
            this.player.play().catch(() => {});
          }
          if (button.hasAttribute('data-motion')) {
            this.previewsPaused = !this.previewsPaused;
            this.updateMotion();
            this.syncPreviews();
          }
        }, { signal });
        this.dialog.addEventListener('close', () => this.release(), { signal });
        this.dialog.addEventListener('keydown', event => {
          if (event.target === this.player || event.target.closest('a, input, select, textarea')) return;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.index + 1);
          }
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this.index - 1);
          }
        }, { signal });
        this.player.addEventListener('volumechange', () => {
          this.unmute.hidden = !this.player.muted && this.player.volume > 0;
        }, { signal });
        this.player.addEventListener('error', () => {
          if (this.dialog.open && this.player.hasAttribute('src')) {
            this.error.hidden = false;
            this.unmute.hidden = true;
          }
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          this.syncPreviews();
          if (document.hidden) this.player.pause();
        }, { signal });
        this.mediaQuery.addEventListener('change', event => {
          this.previewsPaused = event.matches || this.dataset.autoplay !== 'true';
          this.updateMotion();
          this.syncPreviews();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const entry = this.entries.find(item => item.group.dataset.blockId === event.detail.blockId);
          if (entry) this.scrollToCard(entry.card);
        }, { signal });
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(this)) this.destroy();
        }, { signal });
        this.updateArrows();
      }

      mp4(value) {
        if (!value || !value.trim()) return '';
        try {
          const url = new URL(value.trim(), location.origin);
          return /^https?:$/.test(url.protocol) && /\.mp4$/i.test(url.pathname) ? url.href : '';
        } catch (_) { return ''; }
      }

      addEntry(card, group, url) {
        card.dataset.index = String(this.entries.length);
        card.dataset.preview = this.mp4(card.dataset.preview) || url;
        card.setAttribute('aria-label', `${this.dataset.openLabel} ${this.entries.length + 1}${card.dataset.title ? ': ' + card.dataset.title : ''}`);
        const video = card.querySelector('video');
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = false;
        video.addEventListener('loadedmetadata', () => {
          if (this.previewsPaused && Number.isFinite(video.duration) && video.duration > 0) {
            video.currentTime = Math.min(0.01, video.duration / 2);
          }
        }, { signal: this.abort.signal });
        video.addEventListener('loadeddata', () => { card.dataset.ready = ''; }, { signal: this.abort.signal });
        video.addEventListener('error', () => { card.removeAttribute('data-ready'); }, { signal: this.abort.signal });
        this.entries.push({ card, group, url });
      }

      syncPreviews() {
        this.entries.forEach(({ card }) => {
          const video = card.querySelector('video');
          if (this.visible.has(video) && !this.previewsPaused && !document.hidden && !ShoppableVideoStories.active) {
            if (video.paused) video.play().catch(() => {});
          } else video.pause();
        });
      }

      updateMotion() {
        this.motion.textContent = this.previewsPaused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        this.motion.setAttribute('aria-pressed', String(this.previewsPaused));
      }

      updateArrows() {
        const remaining = this.track.scrollWidth - this.track.clientWidth;
        this.querySelector('[data-scroll="-1"]').hidden = remaining < 2 || this.track.scrollLeft < 2;
        this.querySelector('[data-scroll="1"]').hidden = remaining < 2 || this.track.scrollLeft >= remaining - 2;
      }

      scrollCards(direction) {
        const width = this.entries[0]?.card.getBoundingClientRect().width || 110;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 8;
        const count = Math.max(1, Math.floor(this.track.clientWidth / (width + gap)) - 1);
        this.track.scrollBy({ left: direction * count * (width + gap), behavior: this.mediaQuery.matches ? 'instant' : 'smooth' });
      }

      scrollToCard(card) {
        this.track.scrollTo({ left: this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant' });
      }

      open(index, trigger) {
        if (!this.entries[index]) return;
        if (ShoppableVideoStories.active && ShoppableVideoStories.active !== this) {
          const previous = ShoppableVideoStories.active;
          previous.dialog.close();
          previous.release();
        }
        this.trigger = trigger;
        this.player.muted = true;
        if (!this.dialog.open) {
          this.dialog.showModal();
          this.scrollLocks = [document.documentElement, document.body].map(element => ({ element, value: element.style.getPropertyValue('overflow'), priority: element.style.getPropertyPriority('overflow') }));
          this.scrollLocks.forEach(({ element }) => element.style.setProperty('overflow', 'hidden'));
        }
        ShoppableVideoStories.active = this;
        document.querySelectorAll('shoppable-video-stories').forEach(section => section.abort && section.syncPreviews());
        this.show(index);
      }

      show(index) {
        if (!this.entries.length) return;
        this.index = (index + this.entries.length) % this.entries.length;
        const entry = this.entries[this.index];
        this.error.hidden = true;
        this.player.pause();
        this.player.src = entry.url;
        const poster = matchMedia('(max-width: 768px)').matches ? entry.card.dataset.mobilePoster || entry.card.dataset.poster : entry.card.dataset.poster;
        if (poster) this.player.poster = poster;
        else this.player.removeAttribute('poster');
        this.player.setAttribute('aria-label', entry.card.getAttribute('aria-label'));
        this.productList.replaceChildren(entry.group.querySelector('[data-products]').content.cloneNode(true));
        const hasProducts = this.productList.children.length > 0;
        this.productPanel.hidden = !hasProducts;
        this.dialog.toggleAttribute('data-has-products', hasProducts);
        this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.entries.length}`;
        this.querySelector('.svs-player-navigation').hidden = this.entries.length < 2;
        this.unmute.hidden = !this.player.muted && this.player.volume > 0;
        this.player.load();
        this.player.play().catch(() => {});
      }

      release() {
        if (!this.scrollLocks) return;
        this.player.pause();
        this.player.removeAttribute('src');
        this.player.load();
        this.productList.replaceChildren();
        this.scrollLocks.forEach(({ element, value, priority }) => {
          if (value) element.style.setProperty('overflow', value, priority);
          else element.style.removeProperty('overflow');
        });
        this.scrollLocks = null;
        if (ShoppableVideoStories.active === this) ShoppableVideoStories.active = null;
        document.querySelectorAll('shoppable-video-stories').forEach(section => section.abort && section.syncPreviews());
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }

      disconnectedCallback() { this.destroy(); }

      destroy() {
        cancelAnimationFrame(this.startFrame);
        if (!this.abort) return;
        if (this.dialog.open) this.dialog.close();
        this.release();
        this.observer?.disconnect();
        this.resize?.disconnect();
        this.entries.forEach(({ card }) => {
          const video = card.querySelector('video');
          video.pause();
          video.removeAttribute('src');
          video.load();
        });
        this.abort.abort();
        this.abort = null;
      }
    }
    customElements.define('shoppable-video-stories', ShoppableVideoStories);
  }

  } catch(e) { console.error(e); }
})();
})();
